export default __webpack_public_path__ + "static/media/vineRight.cba196ee.svg";